// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"547d46de","453":"45e82763","732":"57f488d3"}[chunkId] + ".chunk.js";
};